import { graphql } from '@/gql';

export const FetchPerformanceResults = graphql(`
    query FetchPerformanceResults($pagination: Pagination, $filter: PerformanceResultFilterRule) {
        performanceResults(pagination: $pagination, filter: $filter) {
            count
            items {
                ...PerformanceResultListItemData
            }
        }
    }
`);

const PerformanceResultListItemData = graphql(`
    fragment PerformanceResultListItemData on PerformanceResult {
        id
        companyId
        company {
            id
            name
        }
        userId
        user {
            __typename
            ... on TenantUser {
                id
                name
                email
            }
            ... on SuperAdminUser {
                id
                name
                email
                isSuperAdmin
            }
        }
        isTiedToAssessmentRun
        assessmentRunId
        assessmentRun {
            name
        }
        result {
            __typename
            ... on WeightResult {
                ...PerformanceResultWeightResultData
            }
            ... on IpptResult {
                ...PerformanceResultIpptResultData
            }
            ... on SocResult {
                ...PerformanceResultSocResultData
            }
            ... on March20kmResult {
                ...PerformanceResultMarch20kmResultData
            }
            ... on FinSwimResult {
                ...PerformanceResultFinSwimResultData
            }
            ... on BmpResult {
                ...PerformanceResultBmpResultData
            }
        }
        createdAt
        completedAt
        updatedBy
        updatedByUser {
            __typename
            ... on TenantUser {
                id
                name
                email
            }
            ... on SuperAdminUser {
                id
                name
                email
                isSuperAdmin
            }
        }
        updatedAt
    }
`);

const PerformanceResultWeightResultData = graphql(`
    fragment PerformanceResultWeightResultData on WeightResult {
        weightKg
    }
`);

const PerformanceResultIpptResultData = graphql(`
    fragment PerformanceResultIpptResultData on IpptResult {
        pushUps
        sitUps
        runTimeSec
        points
        pullUps
        award
    }
`);

const PerformanceResultSocResultData = graphql(`
    fragment PerformanceResultSocResultData on SocResult {
        timingSec
        result
    }
`);

const PerformanceResultMarch20kmResultData = graphql(`
    fragment PerformanceResultMarch20kmResultData on March20kmResult {
        timingSec
        result
    }
`);

const PerformanceResultFinSwimResultData = graphql(`
    fragment PerformanceResultFinSwimResultData on FinSwimResult {
        timingSec
    }
`);

const PerformanceResultBmpResultData = graphql(`
    fragment PerformanceResultBmpResultData on BmpResult {
        percentage
    }
`);

export const DeletePerformanceResultMutation = graphql(`
    mutation DeletePerformanceResult($id: ObjectID!) {
        deletePerformanceResult(id: $id) {
            __typename
            ... on DeletePerformanceResultSuccessfulResponse {
                success
                deletedId
            }
            ... on ErrorResponse {
                fields {
                    field
                    message
                }
            }
        }
    }
`);
